module.exports = __webpack_public_path__ + "static/media/tab-group.be60a9a2.svg";